import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {AboutUsComponent} from './pages/about-us/about-us.component';
import {PageDoesNotExistComponent} from './page-does-not-exist/page-does-not-exist.component';
import {TermsOfUseComponent} from './terms-of-use/terms-of-use.component';
import {ContactComponent} from './pages/contact/contact.component';
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import {HomeComponent} from "./home/home.component";
import {RodoComponent} from "./rodo/rodo.component";

import { BigDataComponent } from './pages/big-data/big-data.component';
import { HurtownieDanychComponent } from './pages/hurtownie-danych/hurtownie-danych.component';
import { OptymalizacjaSystemowComponent } from './pages/optymalizacja-systemow/optymalizacja-systemow.component';
import { BezpieczenstwoComponent } from './pages/bezpieczenstwo/bezpieczenstwo.component';
import { RozwiazaniaDuzejDostepnosciComponent } from './pages/rozwiazania-duzej-dostepnosci/rozwiazania-duzej-dostepnosci.component';


const routes: Routes = [
  {
    path: 'rozwiazania-duzej-dostepnosci',
    component: RozwiazaniaDuzejDostepnosciComponent,
  },
  // {
  //   path: '',
  //   redirectTo: ''
  // },
  {
    path: 'bezpieczenstwo',
    component: BezpieczenstwoComponent,
  },
  // {
  //   path: '',
  //   redirectTo: ''
  // },
  {
    path: 'optymalizacja-systemow',
    component: OptymalizacjaSystemowComponent,
  },
  // {
  //   path: '',
  //   redirectTo: ''
  // },
  {
    path: 'hurtownie-danych',
    component: HurtownieDanychComponent,
  },
  // {
  //   path: '',
  //   redirectTo: ''
  // },
  {
    path: 'big-data',
    component: BigDataComponent,
  },
  // {
  //   path: '',
  //   redirectTo: 'big-data'
  // },


  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'o-nas',
    component: AboutUsComponent
  },
  {
    path: 'about-us',
    redirectTo: 'o-nas'
  },
  {
    path: 'polityka',
    component: PrivacyPolicyComponent
  },
  {
    path: 'rodo',
    component: RodoComponent
  },
  {
    path: 'polityka-prywatnosci',
    redirectTo: 'polityka'
  },
  {
    path: 'privacy-policy',
    redirectTo: 'polityka'
  },
  {
    path: 'warunki',
    component: TermsOfUseComponent
  },
  {
    path: 'warunki-uzytkowania',
    redirectTo: 'warunki'
  },
  {
    path: 'terms-of-use',
    redirectTo: 'warunki'
  },
  {
    path: 'kontakt',
    component: ContactComponent
  },
  {
    path: 'contact',
    redirectTo: 'kontakt'
  },
  {
    path: 'strona-nie-istnieje',
    component: PageDoesNotExistComponent,
  },
  {
    path: 'page-does-not-exist',
    redirectTo: 'strona-nie-istnieje'
  },
 {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


